import * as urlsApi from "../../utils/contants/urlsApi";

import { put, takeLatest } from "redux-saga/effects";

import API from "../../utils/API";
import { Types as MessageTypes } from "../ducks/messages";
import { Types } from "../ducks/formInputs";
import { Types as VacancyTypes } from "../ducks/vacancy";
import { buildErroHandleItems } from "../../helpers/sharedHelpers";

async function getEachInputInfos(url) {
  return await API.get(url)
    .then(res => res.data)
    .catch(error => { throw error });
}

function getAffiliateCenter(id) {
  return API.get(`${urlsApi.formInputFilliate}?IdColigada=${id}`)
    .then(res => res.data)
    .catch(error => {});
}

function getManagerByNameRequest(parameter) {
  var parameter = {Nome:parameter.name, Matricula : parameter.id};
  return API.put(`${urlsApi.formInputAutoComplete}`,
  parameter)

    .then(res => res.data)
    .catch(error => {});
}
function* getManagerByName({ name }) {
  try {
    const managerName = yield getManagerByNameRequest(name);
    yield put({
      type: Types.FORM_INPUTS_SEARCH_BY_NAME_SUCCESS,  managerName
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: messages });
    yield put({ type: Types.FORM_INPUTS_SEARCH_BY_NAME_FAIL, error });
  }
}

function* getAffiliateCenterItems({ idAffiliate }) {
  try {
    const items = yield getAffiliateCenter(idAffiliate);
    yield put({
      type: Types.FORM_INPUTS_AFFILIATE_SUCCESS,
      resultCenter: items
    });
  } catch (error) {
    yield put({ type: Types.FORM_INPUTS_AFFILIATE_FAIL, error });
  }
}

async function getItems(kinds){

  const items = {};
 return Promise.all(
    kinds.map(async (kind) => {
      const item = await getEachInputInfos(urlsApi.formInputsUrls[kind]);
      if (item.escolaridade) {
        items[kind] = item.escolaridade;
        items.benefits = item.beneficios;
        items.banners = item.banners;
        items.competence = item.competencia;
      } else {
        items[kind] = item;
      }
      return items;
    })).then(res => res[0])
    .catch(error => {});
  
} 


function* fillFormVacanyInputs({ kind }) {
  try {
   

  const inputs = yield getItems(kind)
  yield put({ type: Types.FORM_INPUTS_SUCCESS, ...inputs });
  
    
  

  } catch (message) {
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, message });
    yield put({ type: Types.FORM_INPUTS_FAIL, message });
  }
}


function requestGetJobsByArea(idArea) {
  return API.get(`${urlsApi.REQUEST_JOBS_FROM_AREA}?IdArea=${idArea}`)
    .then(res => res.data)
    .catch(error => {});
}

function* getJobsByArea({ idArea }) {
  try {
    const jobs = yield requestGetJobsByArea(idArea);
    yield put({ type: Types.FORM_INPUTS_REQUEST_JOB_FROM_AREA_SUCCESS, jobs });
  } catch (error) {
    yield put({ type: Types.FORM_INPUTS_REQUEST_JOB_FROM_AREA_FAIL, error });
  }
}

function requestPerformaceIndicator() {
  return API.get(`${urlsApi.PERFORMACE_INDICATOR}`)
  .then((response) => response.data)
  .catch((error) => { throw error })
};

function* performaceIndicatior() {
  try {
    const response = yield requestPerformaceIndicator();
    const indicator = response.map(value => {
      return {
        id: value.id ? value.id : null,
        name: value.nome ? value.nome : null
      };
    });
    yield put({
      type: Types.PERFORMACE_INDICATIOR_SUCCESS,
      indicatorsperformaceIndicatior: indicator
    });
  } catch (err) {
    const messages = buildErroHandleItems(err.response);
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages: messages });
    yield put({ type: Types.PERFORMACE_INDICATIOR_FAIL, err });
  }
};

export function* watcherSaga() {
  yield takeLatest(Types.FORM_INPUTS_REQUEST, fillFormVacanyInputs);
  yield takeLatest(
    Types.FORM_INPUTS_AFFILIATE_REQUEST,
    getAffiliateCenterItems
  );

  yield takeLatest(Types.FORM_INPUTS_SEARCH_BY_NAME_REQUEST, getManagerByName);
  yield takeLatest(Types.FORM_INPUTS_REQUEST_JOB_FROM_AREA, getJobsByArea);
  yield takeLatest(Types.PERFORMACE_INDICATIOR_REQUEST, performaceIndicatior);
}
